import axiosInstance from "../../../Axios/Axios"

const GetKeyResultMeetingHistory=async({queryKey}:any)=>{
    let krId=queryKey[1];
    let prId=queryKey[2];
    let profileTenantId=queryKey[3];
    // console.log(prId,"api")
return await axiosInstance.get(`Meeting/GetKeyResultMeetingHistory?tenantId=${profileTenantId}&periodId=${prId}&keyResultId=${krId}`)
}

const GetKeyResultMeetingHistory1=async({queryKey}:any)=>{
  let krId=queryKey[1];
  let prId=queryKey[2];
  let profileTenantId=queryKey[3];
  // console.log(prId,"api")
return await axiosInstance.get(`Meeting/GetKeyResultsMeetingHistory?tenantId=${profileTenantId}&periodId=${prId}&keyResultId=${krId}`)
}

const GetBAUMeetingHistory=async({queryKey}:any)=>{
  let krId=queryKey[1];
  let prId=queryKey[2];
  let profileTenantId=queryKey[3];
return await axiosInstance.get(`Index/GetBAUMeetingHistory?tenantId=${profileTenantId}&periodId=${prId}&keyResultId=${krId}`)
}

const GetCommitMeetingHistory=async({queryKey}:any)=>{
  let meetingId=queryKey[1];
  let id=queryKey[2];
return await axiosInstance.get(`Meeting/GetAllCommitmentsCheckinMeeting?meetingId=${meetingId}&keyResultId=${id}`)
}

const GetAllTeamChildByParentId=async({queryKey}:any)=>{
    let ids=queryKey[1];
   if (ids.teamId.length>2) {
    return await axiosInstance.get(`Meeting/GetAllTeamChildByParentId?teamId=${ids.teamId}&periodId=${ids.priodId}&meetingId=${ids.meetingId}`)
   }
}

const GetAllPersonMeetingByParentId=async({queryKey}:any)=>{
  let ids=queryKey[1];
 if (ids.teamId.length>2) {
  return await axiosInstance.get(`Meeting/GetAllPersonMeetingByParentId?teamId=${ids.teamId}&periodId=${ids.priodId}&meetingId=${ids.meetingId}`)
 }
}

const addCheckinMeeting=async(checkinData:any)=>{
return await axiosInstance.post('Meeting/AddCheckinMeeting',checkinData)
}

const addCommitmentsCheckinMeeting=async(checkinData:any)=>{
  return await axiosInstance.post('Meeting/AddCommitmentsCheckinMeeting',checkinData)
  }

const addCommitments=async(checkinData:any)=>{
  return await axiosInstance.post('OKR/AddCommitments',checkinData)
  }

const addDeterminingSituationAlignmentMeeting=async(checkinData:any)=>{
  return await axiosInstance.post('Meeting/AddDeterminingSituationAlignmentMeeting',checkinData)
  }

const addCheckinBAUMeeting=async(checkinData:any)=>{
  return await axiosInstance.post('Index/AddCheckinMeeting',checkinData)
  }

const GetKeyResultHistoryCheckinByKeyResultId=async({queryKey}:any)=>{
    let mainIds=queryKey[1];
    let{meetingId,periodId,keyResultId}=mainIds
    return axiosInstance.get(`Meeting/GetKeyResultHistoryCheckinByKeyResultId?meetingId=${meetingId}&periodId=${periodId}&keyResultId=${keyResultId}`)
}

const GetAllCommitments=async({queryKey}:any)=>{
  let meetingId=queryKey[1];
  let periodId=queryKey[2];
  return axiosInstance.get(`OKR/GetAllCommitments?id=${meetingId}&periodId=${periodId}`)
}

const GetAllCommitmentsByPeriodId=async({queryKey}:any)=>{
  let meetingId=queryKey[1];
  return axiosInstance.get(`OKR/GetAllCommitmentsByPeriodId?periodId=${meetingId}`)
}

const GetBAUHistoryCheckinByIdQuery=async({queryKey}:any)=>{
  let mainIds=queryKey[1];
  let{meetingId,periodId,keyResultId}=mainIds
  return axiosInstance.get(`Index/GetBAUHistoryCheckinById?meetingId=${meetingId}&periodId=${periodId}&bAUId=${keyResultId}`)
}

const likeMeeting = async (delteKrBody: any) => {
    return await axiosInstance.post(`OKR/AddLikeMeetingObjective`, delteKrBody);
  };
  
  const disLikeMeeting = async (delteKrBody: any) => {
    return await axiosInstance.post(`OKR/AddDisLikeMeetingObjective`, delteKrBody);
  };

  const AddLikeMeetingKeyResult = async (delteKrBody: any) => {
    return await axiosInstance.post(`OKR/AddLikeMeetingKeyResult`, delteKrBody);
  };
  
  const disAddDisLikeMeetingKeyResult = async (delteKrBody: any) => {
    return await axiosInstance.post(`OKR/AddDisLikeMeetingKeyResult`, delteKrBody);
  };

  const getTeamDetail = async ({ queryKey }: any) => {
    let objId: string | null = queryKey[1];
    return await axiosInstance.get(`Team/GetTeamDetail/?id=${objId}`);
  };
  
  const getMyKeyResultByTenantId=async({queryKey}:any)=>{
    let periodId=queryKey[1];
    let profileTenantId=queryKey[2];
    let personId=queryKey[3];
    return await axiosInstance.get(`/OKR/GetMyKeyResultsByTenantId/?tenantId=${profileTenantId}&periodId=${periodId}&personId=${personId}`)
}

export{
    GetKeyResultMeetingHistory,
    GetKeyResultMeetingHistory1,
    GetBAUMeetingHistory,
    GetAllTeamChildByParentId,
    addCheckinMeeting,
    addCommitments,
    addDeterminingSituationAlignmentMeeting,
    GetAllPersonMeetingByParentId,
    addCheckinBAUMeeting,
    GetKeyResultHistoryCheckinByKeyResultId,
    GetBAUHistoryCheckinByIdQuery,
    likeMeeting,
    getTeamDetail,
    getMyKeyResultByTenantId,
    disAddDisLikeMeetingKeyResult,
    GetCommitMeetingHistory,
    GetAllCommitmentsByPeriodId,
    AddLikeMeetingKeyResult,
    GetAllCommitments,
    addCommitmentsCheckinMeeting,
    disLikeMeeting
}